<template lang="pug">
#yotpo-testimonials-custom-tab
  span(class='text-xl') Loading...
</template>
<script setup lang="ts">
useYotpo()
</script>
